import { SHOWCASE_SECTIONS } from './showcaseContent';
import { WORKFLOWS } from './workflowContent';
import { INTRO_TEXT, OUTRO_TEXT } from './brandContent';

const LOWER = new Set(('open click enter add choose pick select search type filter use see switch set scan save review check '
  + 'read track issue record fill plot mark send compare upload invite decide follow scroll create collect note tick '
  + 'export book register log start edit view right-click the each every it a an watch give keep').split(' '));
const LEADS = ['First', 'Next', 'Then', 'After that'];

const sentence = (s) => {
  const [w, ...rest] = s.split(' ');
  const lw = w.toLowerCase();
  const word = lw === 'see' ? 'you will see' : lw === 'watch' ? 'you can see' : LOWER.has(lw) ? lw : w;
  return `${[word, ...rest].join(' ').replace(/[.\s]+$/, '')}.`;
};

const slug = (t) => t.toLowerCase().replace(/[’']/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

export const narrate = (wf) => {
  const n = wf.steps.length;
  const body = wf.steps.map((s, i) => {
    const lead = i === n - 1 && n > 1 ? 'Finally' : LEADS[Math.min(i, LEADS.length - 1)];
    return `${lead}, ${sentence(s)}`;
  });
  return `${wf.intro} ${body.join(' ')}`;
};

export const seconds = (text) => Math.max(10, Math.round((text.split(/\s+/).length / 140) * 60));

export const buildScript = () => SHOWCASE_SECTIONS.map((s, i) => {
  const no = String(i + 1).padStart(2, '0');
  return {
    no, title: s.title, overview: s.value, slug: slug(s.title),
    overviewShot: s.shots.map((x) => `showcase/${x}.png`).join(', '),
    workflows: (WORKFLOWS[s.id] || []).map((wf, j) => {
      const text = narrate(wf);
      return {
        ref: `${no}.${j + 1}`, title: wf.title, text, secs: seconds(text),
        shotName: `${no}.${j + 1}-${slug(wf.title)}.png`, shotFile: `showcase/wf/${wf.id}.png`,
      };
    }),
  };
});

// Flat list of narration clips: intro (00.0), module overview (NN.0) + each workflow (NN.M), outro (99.0).
export const buildClips = () => [
  { ref: '00.0', name: '00.0-intro', text: INTRO_TEXT, shots: [], title: 'Intro' },
  ...buildScript().flatMap((m) => [
  { ref: `${m.no}.0`, name: `${m.no}.0-${slug(m.title)}`, text: `${m.title}. ${m.overview}`,
    shots: m.overviewShot.split(', '), title: m.title },
  ...m.workflows.map((w) => ({ ref: w.ref, name: w.shotName.replace(/\.png$/, ''), text: w.text, shots: [w.shotFile], title: w.title })),
  ]),
  { ref: '99.0', name: '99.0-outro', text: OUTRO_TEXT, shots: [], title: 'Outro' },
];
